import { gql } from '@apollo/client';
import {
  GetUsersQuery,
  GetUsersQueryVariables,
} from '__generated__/queries-auth';
import { useFetch } from '../../../utils/useFetch';

const GET_USERS = gql`
  query GetUsers($first: Int = 20, $skip: Int = 0, $where: UserWhereInput) {
    users(first: $first, skip: $skip, where: $where) {
      id
      name
      createdAt
      email
      roles
      googleId
      departments(first: 100) {
        department {
          name
        }
      }
      userRoles(first: 100) {
        role {
          slug
        }
        brand {
          key
        }
      }
    }
    userCount(where: $where)
  }
`;

export const useGetUsers = () =>
  useFetch<GetUsersQuery, GetUsersQueryVariables>(GET_USERS);
